import { combineReducers, configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';

// reducers
import fileReducer from './file/slice';
import userReducer from './user/slice';
import toursSlice from './tour/slice';
import patientsSlice from './patients/slice';
import callSlice from './call/slice';

const rootReducer = combineReducers({
  user: userReducer,
  file: fileReducer,
  tours: toursSlice,
  patients: patientsSlice,
  call: callSlice
});

const persistConfig = {
  key: 'v1',
  blacklist: ['user', 'call'],
  storage
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);
